import { render, staticRenderFns } from "./service-agreement.vue?vue&type=template&id=2ecaf7e2&scoped=true&"
import script from "./service-agreement.vue?vue&type=script&lang=js&"
export * from "./service-agreement.vue?vue&type=script&lang=js&"
import style0 from "./service-agreement.vue?vue&type=style&index=0&id=2ecaf7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecaf7e2",
  null
  
)

export default component.exports